import Card from '../card';
import FeedbackEmail from '../feedback-email';

/**
 * AboutContact component is used on the About page to display contact information.
 *
 * props: none
 */

const AboutContact = () => (
	<Card cardTitle="Contact me">
		<p>Got any comments, questions or suggestions? Or maybe you've found a bug on the website? You can contact me at the following address:</p>

		<p>
			<FeedbackEmail />
		</p>
	</Card>
);

export default AboutContact;



// WEBPACK FOOTER //
// ./components/about/about-contact.js